import 'bootstrap/dist/css/bootstrap.min.css'
import 'admin-lte/dist/css/AdminLTE.min.css'
import 'admin-lte/dist/css/skins/_all-skins.min.css'
import 'font-awesome/css/font-awesome.min.css'



//////////////////
// WEBPACK FOOTER
// ./~/vue2-admin-lte/src/lib/css.js
// module id = 1169
// module chunks = 0